import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _withScopeId = n => (_pushScopeId("data-v-0bda1356"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "box_for_news_detail" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { id: "box_bg" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "box_icon",
  src: _imports_0
}, null, -1))
const _hoisted_5 = {
  key: 0,
  id: "box_for_news_title"
}
const _hoisted_6 = {
  key: 1,
  id: "box_for_news_time"
}
const _hoisted_7 = {
  key: 2,
  id: "box_for_news_des"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoxWithBtn = _resolveComponent("BoxWithBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      id: "box_for_news_img",
      src: _ctx.item.conver
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_ctx.item.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.item.title), 1))
        : _createCommentVNode("", true),
      (_ctx.item.date)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.item.date), 1))
        : _createCommentVNode("", true),
      (_ctx.item.abstract)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.item.abstract), 1))
        : _createCommentVNode("", true),
      (_ctx.item.link)
        ? (_openBlock(), _createBlock(_component_BoxWithBtn, {
            key: 3,
            text: "了解详情",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDetail(_ctx.item.link))),
            class: "news_des_btn"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}